import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function AdminModal({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
  size = 'md',
  as: Tag = 'div',
  onSubmit,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const panelProps = Tag === 'form'
    ? { onSubmit: (event) => { event.preventDefault(); onSubmit?.(event); } }
    : {};

  return createPortal(
    <div className="admin-page admin-modal" role="dialog" aria-modal="true" aria-label={title}>
      <div className="admin-modal__backdrop" onClick={onClose} />
      <Tag className={`admin-modal__panel admin-modal__panel--${size}`} {...panelProps}>
        <div className="admin-modal__head">
          <div>
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="admin-icon-btn" onClick={onClose} aria-label="Close" title="Close (Esc)">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="admin-modal__body">{children}</div>
        {footer && <div className="admin-modal__foot">{footer}</div>}
      </Tag>
    </div>,
    document.body,
  );
}
